// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { ProductListControlsContainerStyles } from "@rugby/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

const breakpointForProductsCount = 940;
const customControlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-top: 1px solid ${getColor("common.border")};
            padding-top: 13px;
            align-items: center;

            ${MediaQuery.lte(breakpointForProductsCount)} {
                flex-direction: column;
            }
        `,
    },
    countGridItem: {
        css: css`
            ${MediaQuery.lte(breakpointForProductsCount)} {
                margin-bottom: 16px;
            }
        `,
    },
    rightActionContainer: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            ${MediaQuery.lte(600)} {
                flex-direction: column;
            }
        `,
    },
    paginationGridItem: {
        css: css`
            ${MediaQuery.lte(600)} {
                margin: 8px 0 0;
            }
        `,
    },
    sortGridItem: {
        css: css`
            margin: 0 40px 0 20px;
            ${MediaQuery.lte(600)} {
                margin: 8px 0 0;
            }
        `,
    },
    viewSelectGridItem: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

export default customControlsContainerStyles;
